import http from '@services/http'
import {
  IJoinTerms,
  IJoinUsableAccount,
  IJoinUsableNickName,
  IJoinUsableEmail,
  IJoinUsableRecommender,
  IJoinUser,
  IJoinReAuthentication,
  IKeepUserInfo,
  IJoinUsableInvitorNickName,
  IFirstJoinAt,
} from '@protocol/join'

export default {
  getJoinTerms(data: IJoinTerms.Params): Promise<IJoinTerms.Schema> {
    return http.post('join/joinTerms', data || {})
  },
  checkUsableAccount(data: IJoinUsableAccount.Params): Promise<IJoinUsableAccount.Schema> {
    return http.post('join/checkUsableAccount', data || {})
  },
  checkUsableNickName(data: IJoinUsableNickName.Params): Promise<IJoinUsableNickName.Schema> {
    return http.post('join/checkUsableNickName', data || {})
  },
  checkUsableEmail(data: IJoinUsableEmail.Params): Promise<IJoinUsableEmail.Schema> {
    return http.post('join/checkUsableEmail', data || {})
  },
  checkUsableRecommender(data: IJoinUsableRecommender.Params): Promise<IJoinUsableRecommender.Schema> {
    return http.post('join/checkUsableRecommender', data || {})
  },
  checkUsableInvitorNickName(data: IJoinUsableInvitorNickName.Params): Promise<IJoinUsableInvitorNickName.Schema> {
    return http.post('join/checkUsableInvitorNickName', data || {})
  },
  joinUser(data: IJoinUser.Params): Promise<IJoinUser.Schema> {
    return http.post('join/joinUser', data || {})
  },
  reAuthentication(data: IJoinReAuthentication.Params): Promise<IJoinReAuthentication.Schema> {
    return http.post('join/reAuthentication', data || {})
  },
  getKeepUserInfo(data: IKeepUserInfo.Params): Promise<IKeepUserInfo.Schema> {
    return http.post('join/getKeepUserInfo', data || {})
  },
  getFirstJoinAt(data: IFirstJoinAt.Params): Promise<IFirstJoinAt.Schema> {
    return http.post('join/getFirstJoinAt', data || {})
  },
}
